import {apiClient} from 'core/apiClient';
import {AuditExportFormat} from 'types/audit-log';
import {
    WithdrawalAuditEntry,
    WithdrawalAuditPage,
    WithdrawalAuditParams,
} from 'types/withdrawal-audit';

const URL = '/marking/withdrawal/audit-log';

export async function fetchWithdrawalAuditLog(params: WithdrawalAuditParams) {
    return (await apiClient.get<WithdrawalAuditPage>(URL, {params})).data;
}

export async function fetchWithdrawalAuditEvent(id: string) {
    return (await apiClient.get<WithdrawalAuditEntry>(`${URL}/${id}`)).data;
}

export async function exportWithdrawalAuditEvent(id: string) {
    return (await apiClient.get<Blob>(`${URL}/${id}/export`, {responseType: 'blob'})).data;
}

export async function exportWithdrawalAuditLog(
    params: WithdrawalAuditParams & {format: AuditExportFormat; from: string; to: string},
) {
    return {
        data: (await apiClient.get<Blob>(`${URL}/export`, {params, responseType: 'blob'})).data,
    };
}
